const startedKey = (projectId) => `validaite-intake-started-${projectId}`;

export function saveIntakeStartedAt(projectId, iso) {
  if (!projectId || !iso) return;
  try {
    localStorage.setItem(startedKey(projectId), iso);
  } catch {
    /* ignore */
  }
}

export function loadIntakeStartedAt(projectId) {
  if (!projectId) return null;
  try {
    return localStorage.getItem(startedKey(projectId));
  } catch {
    return null;
  }
}

export function clearIntakeStartedAt(projectId) {
  if (!projectId) return;
  try {
    localStorage.removeItem(startedKey(projectId));
  } catch {
    /* ignore */
  }
}

/** Resolve onboarding start time from API fields, then localStorage, then now. */
export function resolveIntakeStartedAt(projectId, { progressStartedAt, sessionStartedAt } = {}) {
  const startedAt =
    progressStartedAt ||
    sessionStartedAt ||
    loadIntakeStartedAt(projectId) ||
    new Date().toISOString();
  saveIntakeStartedAt(projectId, startedAt);
  return startedAt;
}
